export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1707526176242-e9761fd81483?crop=entropy&cs=srgb&fm=jpg&q=85",
  excavator: "https://images.unsplash.com/photo-1728069185264-ed82a210f385?crop=entropy&cs=srgb&fm=jpg&q=85",
  civil: "https://images.unsplash.com/photo-1650127664508-30f4321d9192?crop=entropy&cs=srgb&fm=jpg&q=85",
  sunset: "https://images.unsplash.com/photo-1579847188804-ecba0e2ea330?crop=entropy&cs=srgb&fm=jpg&q=85",
  structure: "https://images.unsplash.com/photo-1618738359576-3c4f259badb6?crop=entropy&cs=srgb&fm=jpg&q=85",
  realestate: "https://images.unsplash.com/photo-1765886471177-94cd112f89d3?crop=entropy&cs=srgb&fm=jpg&q=85",
  facade: "https://images.unsplash.com/photo-1689770256234-ddfd315e3b2b?crop=entropy&cs=srgb&fm=jpg&q=85",
  silhouette: "https://images.unsplash.com/photo-1636988285188-6d9400c4f07f?crop=entropy&cs=srgb&fm=jpg&q=85",
};

export const SERVICES = [
  {
    num: "01",
    slug: "civil",
    titleJa: "土木工事",
    titleEn: "CIVIL ENGINEERING",
    desc: "造成、整地などを中心とした各種土木工事。土地や建物の基盤づくりを行う事業。",
    detail: "宅地造成、事業用地の整地、外構・擁壁工事まで、あらゆる土木工事に対応します。すべての建設は「基盤」から。私たちは測量・設計段階から関わり、土地の特性を見極めた確かな施工で、建物や街の土台をつくります。",
    scope: ["宅地・事業用地の造成工事", "整地・地ならし", "擁壁・外構工事", "基礎土工事"],
    image: "https://images.unsplash.com/photo-1638207849658-e57be0cdc208?fm=jpg&q=80&w=1600&auto=format&fit=crop",
  },
  {
    num: "02",
    slug: "maintenance",
    titleJa: "草刈り・環境整備",
    titleEn: "LAND MAINTENANCE",
    desc: "土地、施設、事業用地などの草刈りや環境整備を行い、土地の維持管理を支援。",
    detail: "放置された土地は資産価値を下げ、近隣トラブルの原因にもなります。定期契約による草刈り・除草・清掃で、土地・施設・事業用地の環境を常に最適な状態に保ち、オーナー様の維持管理負担を軽減します。",
    scope: ["定期草刈り・除草", "空地・空き地の維持管理", "施設外周の環境整備", "年間管理契約"],
    image: "https://images.unsplash.com/photo-1630770147528-3c38bc9e05a6?fm=jpg&q=80&w=1600&auto=format&fit=crop",
  },
  {
    num: "03",
    slug: "cutting",
    titleJa: "伐採工事",
    titleEn: "TREE REMOVAL",
    desc: "敷地内の樹木や支障木の伐採など、安全で利用しやすい土地環境を整備。",
    detail: "開発予定地の支障木、老朽化した危険木、敷地内の不要樹木まで、安全を最優先に伐採・抜根・整地を行います。重機と熟練の技術で、次の活用につながる「使える土地」へと整えます。",
    scope: ["支障木・危険木の伐採", "敷地内樹木の伐採・抜根", "林地の開拓・整備", "伐採後の整地"],
    image: "https://images.unsplash.com/photo-1474742509976-ddec6b387356?fm=jpg&q=80&w=1600&auto=format&fit=crop",
  },
  {
    num: "04",
    slug: "solar",
    titleJa: "太陽光発電設備工事",
    titleEn: "SOLAR PLANT WORKS",
    desc: "太陽光発電所の設置に伴う施工、土地整備などの再生可能エネルギー関連工事。",
    detail: "太陽光発電所の建設に不可欠な造成・基礎・架台設置工事を手がけます。伐採から造成、施工、完成後の除草・維持管理まで、再生可能エネルギー事業をワンストップで支える土木力が私たちの強みです。",
    scope: ["発電所用地の造成", "基礎・架台設置工事", "パネル設置に伴う土木工事", "竣工後の維持管理・除草"],
    image: "https://images.unsplash.com/photo-1668097613572-40b7c11c8727?fm=jpg&q=80&w=1600&auto=format&fit=crop",
  },
  {
    num: "05",
    slug: "realestate",
    titleJa: "不動産管理・開発事業",
    titleEn: "REAL ESTATE",
    desc: "アパート、マンション、店舗、事業用物件、土地などの管理・取得・活用・開発。",
    detail: "アパート・マンション・店舗・事業用物件・土地の管理から取得、活用、開発までを一貫して行います。建設会社としての施工・維持管理のノウハウを活かし、不動産価値の向上を目指します。",
    scope: ["賃貸物件の管理運営", "土地・物件の取得", "土地活用の企画提案", "自社開発案件の推進"],
    image: IMAGES.realestate,
  },
];

export const COMPANY = {
  name: "株式会社ネオ建設",
  nameEn: "NEO CONSTRUCTION",
  zip: "〒514-0016",
  address: "三重県津市乙部27番10号",
  corporateNumber: "3180001137589",
  ceo: "黒崎 龍一",
  tel: "059-000-0000",
  fax: "059-000-0001",
  email: "info@neo-construction.example.jp",
  hours: "8:00 – 17:00",
  holiday: "日曜・祝日・GW・年末年始",
  founded: "2015年4月1日",
  capital: "2,000万円",
  employees: "18名",
  license: "三重県知事許可（般-7）第00000号",
  licenseTypes: "土木工事業・とび・土工工事業・解体工事業",
  invoice: "T3180001137589",
  area: "三重県・東海地域",
  banks: "百五銀行 津支店 / 三重銀行 津支店",
  qualifications: "2級土木施工管理技士、1級造園施工管理技士、職長・安全衛生責任者 ほか",
};

export const FLOW_STEPS = [
  { num: "01", title: "土地を整える", desc: "造成・整地・伐採・環境整備で、土地のポテンシャルを引き出す。", detail: "測量・伐採・造成・整地まで、土地が持つポテンシャルを最大限に引き出します。地盤の特性を見極めた施工で、後のすべての工程の品質を左右する「土台」をつくります。" },
  { num: "02", title: "建設する", desc: "土木から建築基盤、太陽光設備まで。確かな施工で形にする。", detail: "土木工事から建築基礎、太陽光発電設備まで。確かな施工管理と熟練の技術で、設計を忠実に形にします。安全と品質を両立させた現場づくりを徹底しています。" },
  { num: "03", title: "維持管理する", desc: "草刈り・環境整備・物件管理で、資産価値を守り続ける。", detail: "草刈り・環境整備・物件の維持管理を定期契約で実施します。土地や建物は手入れをしなければ価値が下がります。資産価値を守り続ける継続的なサポートです。" },
  { num: "04", title: "活用・開発する", desc: "不動産として活用・開発し、土地の価値を最大化する。", detail: "不動産の管理・取得・活用・開発を一貫して行います。遊休地の活用提案から自社開発まで、建設会社ならではの目線で土地の価値を最大化します。" },
];

export const NAV_LINKS = [
  { to: "/about", label: "ABOUT", ja: "私たちについて" },
  { to: "/service", label: "SERVICE", ja: "事業内容" },
  { to: "/works", label: "WORKS", ja: "施工実績" },
  { to: "/real-estate", label: "REAL ESTATE", ja: "不動産事業" },
  { to: "/company", label: "COMPANY", ja: "会社概要" },
  { to: "/recruit", label: "RECRUIT", ja: "採用情報" },
];

export const INQUIRY_TYPES = ["工事依頼", "見積依頼", "不動産相談", "協力会社", "採用の問い合わせ", "その他"];

export const HISTORY = [
  { year: "2019", label: "FOUNDATION", text: "株式会社ネオ建設 設立" },
  { year: "2021", label: "MIE", text: "三重県津市へ本店移転、地域に根ざした建設事業を本格展開" },
  { year: "2026", label: "EXPANSION", text: "不動産管理・開発事業へ事業領域を拡大" },
  { year: "NEXT", label: "FUTURE", text: "建設から不動産へ。土地と建物の新たな価値を創造する企業へ。" },
];
